import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// BrowserRouter drops the query string on every navigate(); under HashRouter the pre-hash
// ?lang=en (and other entry params) survived the booking steps. Keep that behaviour.
const useNavigateWithSearch = () => {
    const navigate = useNavigate();
    const { search } = useLocation();
    return useCallback((pathname, options) => navigate({ pathname, search }, options), [navigate, search]);
};

export { useNavigateWithSearch };
